import { render, staticRenderFns } from "./PlayerConfigBasicConfig.vue?vue&type=template&id=225c6c39&scoped=true&"
import script from "./PlayerConfigBasicConfig.vue?vue&type=script&lang=js&"
export * from "./PlayerConfigBasicConfig.vue?vue&type=script&lang=js&"
import style0 from "./PlayerConfigBasicConfig.vue?vue&type=style&index=0&id=225c6c39&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225c6c39",
  null
  
)

export default component.exports